import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { throttle } from '@kluntje/js-utils/lib/function-helpers/index.js';
import { toggleClass } from '@kluntje/js-utils/lib/dom-helpers/index.js';

@customElement('man-to-top')
export class ManToTop extends LitElement {
  private scrollTimer: number | null = null;
  private showClass = 'man-to-top--visible';

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.toggleAttribute('inert', true);
    window.addEventListener('scroll', throttle(this.handleScroll, 250));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', throttle(this.handleScroll, 250));
  }

  handleScroll = () => {
    this.setVisible(false);

    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }

    this.scrollTimer = window.setTimeout(() => {
      this.setVisible(window.scrollY > document.body.clientHeight * 0.4);
    }, 250);
  };

  private setVisible(visible: boolean) {
    const isCurrentlyVisible = this.classList.contains(this.showClass);
    if (isCurrentlyVisible === visible) return;

    toggleClass(this, this.showClass, visible);
    this.toggleAttribute('inert', !visible);
  }

  protected firstUpdated() {
    const topUsedSalesTool = document.getElementById('top-used-sales-tools-m68');
    const fixedPopover = document.querySelector('man-popover-menu[placement="fixed"]');

    toggleClass(this, 'man-to-top--with-top-used-sales-tool', Boolean(topUsedSalesTool));
    toggleClass(this, 'man-to-top--with-fixed-popover', Boolean(fixedPopover));
  }

  render() {
    return html`
      <craft-button
        @click=${() => this.scrollToTop()}
        aria-label="Scroll to top"
        icon-only="true"
        icon-name="chevron-up"
        purpose="standard"
        variant="primary"
        size="m"></craft-button>
    `;
  }

  private scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
